function BlogPosts() {
  return (
    <>
      {/* <header className="header">
        <h1>Writings</h1>
      </header>
      <section className="main">
        <p>in progress</p>
        <div>
          <h2>On PLO_radio</h2>
          <h3>
            the legacy of Berlin Community Radios most seminal radio show and
            the influence of online radio in defining community and aesthetic in
            underground dance music culture.
          </h3>
          <p>
            Dance Music, underground and marginalized cultures by their
            institution often resists contemporary claims for memorialization,
            solidification and institutionalization.
          </p>
        </div>
        <div>
          <h2>Phenomological engagement with the machine</h2>
          <h3>What</h3>
        </div>
        <div>
          <h2></h2>
        </div>
      </section> */}
      <header className="header">
        <h1>Writings</h1>
      </header>
      <section>
        <p>In progression...</p>
      </section>
    </>
  )
}

export default BlogPosts
